import { Component, EventEmitter, inject, Output, DestroyRef, computed, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { GlobalFlightInfoService, HttpService, ThemeService, UtilityService } from '../../../services';
import { HttpHeaders } from '@angular/common/http';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import { MAIN_NAV, AUTH_PROFILE } from '../../constants/navigation';
import { XchangeratesService } from '../../../services/flight/xchangerates.service';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialog } from '@angular/material/dialog';
import { AuthStateService } from '../../../services/global/auth-state.service';
import { AuthComponent } from '../../auth/auth.component';
import { StorageService } from '../../../services/storage.service';

import { BrokenImageUrlPipe } from '../../../pipe/broken-image-url.pipe';

@Component({
  selector: 'app-header',
  imports: [RouterLink, RouterLinkActive, MatButtonModule, MatMenuModule, MatIconModule, MatExpansionModule, CommonModule, BrokenImageUrlPipe],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  @Output() toggleSidebar = new EventEmitter<void>();
  
  private svc = inject(XchangeratesService);
  public authState = inject(AuthStateService);
  public theme = inject(ThemeService);
  public util = inject(UtilityService);
  readonly dialog = inject(MatDialog);
  private destroyRef = inject(DestroyRef);

  user = toSignal(this.authState.user$);
  userInitials = computed(() => this.getInitials(this.user()?.name));

  WEBSITE_INFO: any;
  mainNav = MAIN_NAV;
  authProfile = AUTH_PROFILE;
  currency: any[] = [];
  currencySelected: any = null;
  public router = inject(Router);
  private storage = inject(StorageService);
  constructor(private http: HttpService, private globalWebsite: GlobalFlightInfoService) {
    this.globalWebsite.WEBSITE_INFO().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data) => {
        this.WEBSITE_INFO = data?.data;
      },
      error: () => {}
    });
  }
  ngOnInit() {
    this.currency = this.safe('currency_List') || [];
    this.svc.currency$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(v => v && (this.currencySelected = v));
    this.svc.currencyList();
    this.authState.user$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.imageError = false;
    });
  }

  select(i: any) {
    this.currencySelected = i;
    this.svc.pushCurrencyActive(i);
  }

  private safe(k: string) {
    return this.storage.getParsed(k);
  }
  // switchTheme(theme: string) {
  //   this.themeService.setTheme(theme);
  // }

  authSetting() {
    const dialogRefAuth = this.dialog.open(AuthComponent, {
      panelClass: 'authDialogClass',
      maxWidth: '90vw'
    });
    dialogRefAuth.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      if (result === 'login-success') {
        dialogRefAuth.close();
      }
    });
  }

  imageError = false;

  handleImageError() {
    this.imageError = true;
  }

  getInitials(name?: string): string {
    if (!name) return '';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  logout() {
    this.authState.logout();
  }
}
